import axios from 'axios';

// Action types
export const SET_ERROR = 'SET_ERROR';

// Action creator
export const setFv = (num_se, hook_status) => {
	return async (dispatch) => {
		//console.log(`in setFv, num_se`, num_se);
		if (num_se <= 1) {
			regForm(hook_status, dispatch);
		}
	};
};

function regForm(hook_status, dispatch) {
	if (hook_status == 'live') {
		const form = document.getElementById('reg-form');

		const validator = FormValidation.formValidation(
			form,
			{
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap5({
						rowSelector: '.form-group',
						eleInvalidClass: '',
						eleValidClass: ''
					}),
					autoFocus: new FormValidation.plugins.AutoFocus(),
					submitButton: new FormValidation.plugins.SubmitButton(),
					declarative: new FormValidation.plugins.Declarative({
						html5Input: true
					})
				}
			}
		);

		dispatch({type: 'SET_FV', payload: validator});
	}
}